import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AccessRightsService } from './services/access-rights.service';
import { inject } from '@angular/core';
import { Policy } from '../shared/models/info/policy';
import { concatMap, map, Observable } from 'rxjs';
import { prefixWithSlash } from '../shared/internal/prefix-with-slash';
import { ROUTE_PATHS } from '../shared/constants/route-paths';

export function policyAccessGuard(policy: Policy): CanActivateFn {
  return (): Observable<boolean | UrlTree> => {
    const accessRightsService: AccessRightsService = inject(AccessRightsService);
    const router: Router = inject(Router);

    return accessRightsService
      .getAccessRights$()
      .pipe(
        concatMap(() =>
          accessRightsService
            .isPolicySatisfied$(policy)
            .pipe(
              map((isSatisfied) =>
                isSatisfied ? true : router.createUrlTree([prefixWithSlash(ROUTE_PATHS.insufficientRights)])
              )
            )
        )
      );
  };
}
